module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    attrs: {
      "transform": ("translate(0, -" + (_vm.mapSize.depth) + ")")
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "1.8",
      "width": "1.5",
      "height": "1.5",
      "fill": "black"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "2.2",
      "y": "3",
      "font-size": "1.2",
      "font-weight": "bold",
      "text-anchor": "start"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": _vm.gradientId,
      "x1": "0%",
      "y1": "0%",
      "x2": "100%",
      "y2": "0%"
    }
  }, _vm._l((_vm.gradientStops), function(stop, index) {
    return _c('stop', {
      key: index,
      attrs: {
        "offset": stop.offset,
        "stop-color": stop.color
      }
    })
  }), 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "transform": ("translate(" + (_vm.mapSize.width - _vm.mapSize.width / 3) + ", 0)")
    }
  }, [_c('text', {
    attrs: {
      "x": "0",
      "y": "1.2",
      "font-size": "1.2",
      "text-anchor": "start"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.minValue) + _vm._s(_vm.unit) + "\n    ")]), _vm._v(" "), _c('text', {
    attrs: {
      "x": _vm.mapSize.width / 3,
      "y": "1.2",
      "font-size": "1.2",
      "text-anchor": "end"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.maxValue) + _vm._s(_vm.unit) + "\n    ")]), _vm._v(" "), _c('rect', {
    staticClass: "legend-gradient",
    attrs: {
      "y": "1.8",
      "width": _vm.mapSize.width / 3,
      "height": 1.5,
      "fill": ("url(#" + _vm.gradientId + ")")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3337693a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/map_header.vue
// module id = 871
// module chunks = 0